// import React from 'react';

// function LoadingSpinner() {
//   return (
//     <div className="flex flex-col items-center justify-center gap-3">
//       <div className="w-10 h-10 rounded-full border-4 border-gray-200 border-t-[#4B0000] animate-spin" />
//       <p className="text-sm text-gray-400 tracking-wide">Cargando...</p>
//     </div>
//   );
// }

// export default LoadingSpinner;


import React from 'react';

function LoadingSpinner() {
  return (
    <div className="flex flex-col items-center justify-center gap-4">

      {/* Anillos concéntricos animados */}
      <div className="relative w-12 h-12">
        {/* Anillo exterior — gira lento */}
        <div
          className="absolute inset-0 rounded-full border-2 border-transparent animate-spin"
          style={{
            borderTopColor: "#2f5a2e",
            borderRightColor: "#2f5a2e",
            animationDuration: "1s",
          }}
        />
        {/* Anillo interior — gira en sentido contrario */}
        <div
          className="absolute inset-[6px] rounded-full border-2 border-transparent animate-spin"
          style={{
            borderTopColor: "#cde29a",
            animationDuration: "0.7s",
            animationDirection: "reverse",
          }}
        />
        {/* Punto central */}
        <div
          className="absolute inset-[10px] rounded-full"
          style={{ background: "#2f5a2e", opacity: 0.15 }}
        />
      </div>

      {/* Texto */}
      <div className="flex flex-col items-center gap-0.5">
        <p
          className="font-serif text-[13px] font-semibold text-[#2f5a2e]"
        >
          Frutas Premium
        </p>
        <p className="text-[11px] text-gray-400 tracking-widest uppercase">
          cargando...
        </p>
      </div>

    </div>
  );
}

export default LoadingSpinner;